export const sanitizeText = text =>
  window.encodeURIComponent ? window.encodeURIComponent(text) : text;
